import { Action } from "redux";
import { ISettings } from "@montana/models/generated/cms.interface";

export enum DynamicSettingsAction {
    INIT = "@@dynamic-settings/INIT",
    SET_DYNAMIC_SETTINGS = "@@dynamic-settings/SET_DYNAMIC_SETTINGS"
}

export interface IDynamicSettingsInitAction extends Action<DynamicSettingsAction.INIT> {
    settings?: ISettings;
    cfCountryHeader?: string;
    activeLanguage?: string;
}

export interface ISetDynamicSettingsAction extends Action<DynamicSettingsAction.SET_DYNAMIC_SETTINGS> {
    settings: ISettings;
}

export function initDynamicSettings(settings?: ISettings, cfCountryHeader?: string, activeLanguage?: string): IDynamicSettingsInitAction {
    return { type: DynamicSettingsAction.INIT, settings, cfCountryHeader, activeLanguage };
}

export function setDynamicSettings(settings: ISettings): ISetDynamicSettingsAction {
    return { type: DynamicSettingsAction.SET_DYNAMIC_SETTINGS, settings };
}
